<template>
<div id="LeaseContract">
  <div :class="`loader${loaderClass}`" v-show="loading"></div>
  <div id="page-content-wrapper" class="admin-content-area" >
    <template v-if="cantAccessPage === true">
      <div class="page-name">
        <div class="page-title">Annual Actual Metrics vs Contract Metrics</div>
        <div class="web-action-btn btn-groups text-right">
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                  <i class="fp-export"></i> Export
              </a>
        </div>
      </div>
      <div class="container-fluid">
        <div class="admin-page-content contact-list">
          <data-table-filter-config :moduleName="'actualMetricVSContractMetric'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
          <div class="data-table bg-white overflow-hidden">
            <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
            <section class="bg-white data-table">
              <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange" :moduleName="'actualMetricVSContractMetric'" :position="'top'">
              </custom-pagination>

              <vue-good-table
                  mode="remote"
                  ref="actualMetricVSContractMetricReportTable"
                  title="actualMetricVSContractMetric"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                  :totalRows="totalRecords"
                  :columns="userColumns"
                  :rows="rows"
                  :paginationOptions="{
                      enabled: false,
                      position: 'both',
                      perPage: perPage,
                      dropdownAllowAll: false,
                      setCurrentPage:listCurrentPage,
                      perPageDropdown:dropDownPerPage,
                  }"
                  :search-options="{
                  enabled: false,
                  }"

                  >
              </vue-good-table>
              <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange">
              </custom-pagination>
            </section>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="cantAccessPage === false">
      <div class="container-fluid">
          <div class="bg-white text-center">
              <h1>
                  Oops!</h1>
              <h2>
                  403 </h2>
              <div class="error-details">
                  Sorry!, You don't have permission to access this page.
              </div>
          </div>
      </div>
    </template>
    <template v-else>
      <loading-content></loading-content>
    </template>
    <app-footer></app-footer>
  </div>
</div>
</template>
<script>
import Vue from "vue";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
  name: "LeaseContract",
  metaInfo(){
       return {
         title : 'Annual Actual Metrics vs Contract Metrics | FleetPro Application'
       }
    },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    cantAccessPage:"",
    loading: false,

    permissions:[],
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns:[
      {
          label: 'Unit Number',
          field: 'unit_no',
          fpFieldType:"text",
          hidden:false,
          filterable: true,
      },
      {
          label: 'Equipment Description',
          field: 'vehicle_name',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Facility',
          field: 'location',
          hidden:false,
          filterable: true,
          fpFieldType:"option",
      },
      {
          label: 'Equipment Pool',
          field: 'pool',
          hidden:false,
          filterable: true,
          fpFieldType:"option",
      },
      {
          label: 'Contract Type',
          field: 'conType',
          filterable: true,
          fpFieldType:"option",
      },
      {
          label: 'Agreement Number',
          field: 'agreement_no',
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Customer Number',
          field: 'customer_code',
          fpFieldType:"text",
          filterable: true,
      },
      {
          label: 'Customer Name',
          field: 'customer_name',
          fpFieldType:"text",
          filterable: true,
      },
      {
          label: 'Unit Assignment Date',
          field: 'effective_date',
          hidden:false,
          filterable: true,
          fpFieldType:"custom_date",
      },
      {
          label: 'Expiry Date',
          field: 'expiry_date',
          hidden:false,
          filterable: true,
          fpFieldType:"custom_date",
      },

      {
          label: 'Estimated Contract Metrics',
          field: 'estimate_reading',
          filterable: true,
          type:'number',
          fpFieldType:"integer",
      },
      {
          label: 'UOM',
          field: 'uom',
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Estimated Months',
          field: 'estimate_month',
          filterable: false,
          // type:'number',
          fpFieldType:"text",
      },
      {
          label: 'Term',
          field: 'term',
          filterable: true,
          fpFieldType:"integer",
      },
      {
          label: 'Total Months Elapsed',
          field: 'month_elapsed',
          filterable: false,
          fpFieldType:"text",
          sortable:false
      },
      {
          label: 'Current Year Starting Date',
          field: 'current_year_start_date',
          filterable: false,
          fpFieldType:"date",
          sortable:false
      },
      {
          label: 'Current Year Contract Months Elapsed',
          field: 'current_year_month_elapsed',
          filterable: false,
          fpFieldType:"text",
          sortable:false
      },
      {
          label: 'Current Year Contract Date For Reading',
          field: 'current_year_reading_date',
          filterable: false,
          fpFieldType:"date",
          sortable:false
      },
      {
          label: 'Current Reading Date',
          field: 'current_reading_date',
          filterable: true,
          fpFieldType:"custom_date",
      },
      {
          label: 'Out Reading',
          field: 'reading_out',
          filterable: true,
          fpFieldType:"integer",
          type:'number',
      },
       {
          label: 'Current Year Contract Start Reading',
          field: 'current_year_contract_reading',
          filterable: false,
          fpFieldType:"integer",
          type:'number',
          sortable:false
      },
      {
          label: 'LTD Reading',
          field: 'ltd_reading',
          filterable: true,
          fpFieldType:"integer",
          type:'number',
      },
      {
          label: 'Sub Miles Current Year',
          field: 'sub_miles_current_year',
          filterable: false,
          fpFieldType:"integer",
          type:'number',
          sortable:false
      },
      {
          label: 'Current Year Contract Miles',
          field: 'current_year_contract_miles',
          filterable: false,
          fpFieldType:"integer",
          type:'number',
          sortable:false
      },
      {
          label: 'Sub Miles Total',
          field: 'sub_miles_total',
          filterable: false,
          fpFieldType:"integer",
          type:'number',
          sortable:false
      },
      {
          label: 'Actual Contract Total Metrics',
          field: 'actual_contract_total_reading',
          filterable: false,
          fpFieldType:"integer",
          type:'number',
          sortable:false
      },
       {
          label: 'Current Year Excess Miles',
          field: 'current_year_excess_miles',
          filterable: false,
          fpFieldType:"integer",
          type:'number',
          sortable:false
      },
      {
          label: 'Current Year Annualized Excess Metrics To Date',
          field: 'current_year_excess_miles_to_date',
          filterable: false,
          fpFieldType:"integer",
          type:'number',
          sortable:false
      },
      {
          label: 'Excess Metrics To Date',
          field: 'excess_miles_to_date',
          filterable: false,
          fpFieldType:"integer",
          type:'number',
          sortable:false
      },
      {
          label: 'Annualized Excess Metrics',
          field: 'annualized_excess_miles',
          filterable: false,
          fpFieldType:"integer",
          type:'number',
          sortable:false
      },
      {
          label: 'Variance %',
          field: 'variance',
          filterable: false,
          fpFieldType:"integer",
          type:'number',
          sortable:false
      },
      {
          label: 'Salesperson',
          field: 'sales_person',
          fpFieldType:"text",
          filterable: true,
      },
       {
          label: 'Metric Type',
          field: 'section',
          hidden:false,
          filterable: true,
          fpFieldType:"option",
      },
      {
          label: 'Meter Change',
          field: 'meter_change',
          fpFieldType:"option",
          filterable: false, // as static value is given
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Contract Equipment Statuse", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: ['Yes','No'],
              trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Annual Months For Readings',
          field: 'annual_month_read',
          filterable: false,
          type:'number',
          fpFieldType:"integer",
          sortable:false,
      },
      {
          label: 'Contract Months For Readings',
          field: 'contract_month_read',
          filterable: false,
          type:'number',
          fpFieldType:"integer",
          sortable:false,
      },
      {
          label: 'Annual Estimate To Date',
          field: 'annual_estimate_read',
          filterable: false,
          type:'number',
          fpFieldType:"integer",
          sortable:false,
      },
      {
          label: 'Contract Estimate To Date',
          field: 'contract_estimate_read',
          filterable: false,
          type:'number',
          fpFieldType:"integer",
          sortable:false,
      },
    ],
    action:'list',
    batchProcess:0,
    batchNum:"",
  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'actual_and_contract_metric_report') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  methods:{
    cancelAll: function (cancelAll) {
      this.$refs.leaseContractReportTable.unselectAllInternal();
    },
    loadList: function(){
      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      $.ajax({
        url: process.env.ROOT_API + "/contract-actual-metric-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action:self.action
        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          console.log(data.content.row);
          if (data.status == "success") {
            if (self.action == "export" ||  self.action == "export_queue") {
                if ( data.code == "201" ) {
                    alert(data.message);
                } else {
                    if ( self.action == "export" ) {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);
                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }
                }

              self.action = "list";
            //   self.loadList();
            }else{
              if (data.content.row != undefined) {
                self.rows = data.content.row;
              }
              self.totalRecords = data.content.totalRecords;
            }


          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'lease-contract-list')
        }
      });


    }

  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/AnnualActualMetricVSContractMetric.vue